import { render, staticRenderFns } from "./ImportBrands.vue?vue&type=template&id=524a5ea4&scoped=true"
import script from "./ImportBrands.vue?vue&type=script&lang=js"
export * from "./ImportBrands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524a5ea4",
  null
  
)

export default component.exports